import { http } from "./api";

const endpointBase = 'api/empresas/';

export const getEmpresas = async () => {
    const url = endpointBase
    return http.get(url);
}
